// extracted by mini-css-extract-plugin
export var grayCircle = "_dj-0";
export var renderAfterShippingOptionWidgetPreviewSelected = "_dj-1";
export var selectedCircle = "_dj-2";
export var shippingOptionImage = "_dj-3";
export var shippingOptionWidgetPreview = "_dj-4";